import axios, { AxiosInstance, AxiosRequestConfig } from 'axios';
import { getApiConfig } from '../environment';

export interface AuthenticatedAxiosConfig extends AxiosRequestConfig {
  includeAuth?: boolean;
}

export const createAuthenticatedAxiosInstance = (
  config: AuthenticatedAxiosConfig = {},
  includeAuth: boolean = true,
): AxiosInstance => {

  const apiConfig = getApiConfig();
  const language = localStorage.getItem('language');

  const defaultConfig: AxiosRequestConfig = {
    baseURL: apiConfig.apiBaseUrl,
    ...config,
  };

  const axiosInstance = axios.create(defaultConfig);

  if (includeAuth) {

    axiosInstance.interceptors.request.use((requestConfig) => {

      const storedValue = localStorage.getItem('token');

      const accessToken = storedValue && JSON.parse(storedValue);
      if (accessToken && accessToken !== 'null') {
        requestConfig.headers['Authorization'] = `Bearer ${accessToken}`;
      }

      const selectedStoreValue = localStorage.getItem('selectedStore');
      if (selectedStoreValue && selectedStoreValue !== 'null') {
        try {
          const selectedStore = JSON.parse(selectedStoreValue);
          requestConfig.headers['ews-storeNumber'] = selectedStore.storeNumber || '';
        } catch (error) {
          console.warn('Failed to parse selectedStore from localStorage:', error);
        }
      }

      requestConfig.headers['Accept'] = 'application/json';
      requestConfig.headers['X-Requested-With'] = 'XMLHttpRequest';
      requestConfig.headers['Expires'] = '-1';
      requestConfig.headers['If-Modified-Since'] = 'Thu, 13 Feb 1985 13:40:01 GMT';
      requestConfig.headers['Cache-Control'] = 'no-cache';
      requestConfig.headers['Pragma'] = 'no-cache';

      if (language) {
        requestConfig.headers['Accept-Language'] = language;
      }

      return requestConfig;
    },
    (error) => {
      return Promise.reject(error);
    },
    );

    axiosInstance.interceptors.response.use(
      (response) => {
        return response;
      },
      (error) => {
        const { response } = error;
        if (response && response.status === 401) {
          localStorage.clear();
          if (window.location.pathname !== '/login') {
            window.location.href = '/login';
          }
        }
        return Promise.reject(error);
      },
    );

  }

  return axiosInstance;
};


export const createPublicAxiosInstance = (config: AxiosRequestConfig = {}): AxiosInstance => {
  return createAuthenticatedAxiosInstance(config, false);
};

export const authenticatedAxios = createAuthenticatedAxiosInstance();
